import React from "react";
import { useSpendingDemandPaymentSummary } from "../../../../hooks";
import { numberToStingWithSpaces } from "../../../../../../utils/numberDisplayer";

interface CollabPayedRendererProps {
  spendingDemandId: string;
}

export const CollabPayedRenderer: React.FC<CollabPayedRendererProps> = ({ spendingDemandId }) => {
  const { paymentSummary, isLoading } = useSpendingDemandPaymentSummary(spendingDemandId, {
    disableQuery: !spendingDemandId,
  });

  if (isLoading) {
    return <span style={{ color: "#999", fontSize: "0.8rem" }}>...</span>;
  }

  if (!paymentSummary.totalPayedCollab || paymentSummary.totalPayedCollab === 0) {
    return <span style={{ color: "#999" }}>-</span>;
  }

  return <span>{numberToStingWithSpaces(paymentSummary.totalPayedCollab)}</span>;
};

export default CollabPayedRenderer;
